import { render, staticRenderFns } from "./MedicalForm.vue?vue&type=template&id=3240401d&scoped=true&"
import script from "./MedicalForm.vue?vue&type=script&lang=js&"
export * from "./MedicalForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalForm.vue?vue&type=style&index=0&id=3240401d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240401d",
  null
  
)

export default component.exports